import { render } from "./ColorpaletteView.vue?vue&type=template&id=63f86885&scoped=true"
import script from "./ColorpaletteView.vue?vue&type=script&lang=js"
export * from "./ColorpaletteView.vue?vue&type=script&lang=js"

import "./ColorpaletteView.vue?vue&type=style&index=0&id=63f86885&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63f86885"]])

export default __exports__